module.exports = __webpack_public_path__ + "static/media/folder.cd6da247.ico";